import { assetsImages } from "assets";
import SetupGoogleApp from "./SetupGoogleApp";
import SetupVerify from "./SetupVerify";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { LOGIN_TYPE_EMAIL, LOGIN_TYPE_GA } from "constants/login.constants";

function Setup() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [categorySetup, setCategorySetup] = useState(Number(searchParams.get("type")) || 0);
  const [isSelectMode, setIsSelectMode] = useState(false);

  return (
    <div className="login">
      <div className="forgotPassword__logo">
        <img src={assetsImages.fillLogo} alt="" />
      </div>
      <article className="login forgotPassword">
        {(isSelectMode || categorySetup === LOGIN_TYPE_EMAIL || searchParams.get("selected")) && (
          <SetupVerify
            onBack={() => {
              setIsSelectMode(false);
              searchParams.delete("selected");
              setSearchParams(searchParams);
            }}
          />
        )}
        {categorySetup === LOGIN_TYPE_GA && !isSelectMode && !searchParams.get("selected") && (
          <SetupGoogleApp
            onSetup={() => {
              setIsSelectMode(true);
              searchParams.set("selected", "true");
              setSearchParams(searchParams);
            }}
          />
        )}
      </article>
    </div>
  );
}

export default Setup;
